module.exports = __webpack_public_path__ + "static/media/career-growth.89378a99.svg";